<template>
  <div
    v-if="
      $route.name !== 'lite' &&
      $route.name !== 'accept-invite' &&
      $route.name !== 'store-invitation-accepted'
    "
    :class="
      $route === '/connected-apps'
        ? 'relative z-[99999999]'
        : 'relative z-[99999999]'
    "
  >
    <v-navigation-drawer
      app
      width="270"
      v-model="drawer"
      class="z-50"
      v-if="isAuth"
      @input="$emit('input', drawer)"
      ref="mainNavigationDrawer"
    >
      <!-- <div
        class="flex items-center w-full px-4 space-x-3"
        style="height: 63px;"
      > -->
        <!-- All-white Fly Logo on the left -->
        <!-- <img
          src="@/assets/img/logo-transparent.svg"
          alt="Fly Logo"
          class="h-8"
        /> -->

        <!-- WorkspaceMenu component to the right of the logo -->
        <!-- <workspace-menu class="flex-grow"></workspace-menu> -->
      <!-- </div> -->

      <v-dialog v-model="showDialog" max-width="500">
        <v-card>
          <v-card-title class="headline">
            Time to renew!<v-icon color="error">mdi-bell-ring-outline</v-icon>
            <v-btn
              v-if="showDialog"
              icon
              @click="closeDialog"
              class="close-dialog-btn"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="font-semibold">
            You have run out of credits. Please renew your subscription to keep
            posting!
          </v-card-text>
          <v-card-actions>
            <v-btn @click="closeDialog">Close</v-btn>
            <v-btn @click="renewSubscription" color="primary"
              >Renew<v-icon>mdi-creation</v-icon></v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-divider class="border-slate-200"></v-divider>
      <workspace-menu></workspace-menu>

      <v-list dense nav class="py-1 px-1">
        <template v-for="(item, i) in menus">
          <v-list-item
            :class="active(item) ? 'drawer__active' : 'drawer__inactive'"
            :key="i"
            @click="
              item.name === 'analytics' || item.name === 'gmb' || item.name === 'social' || item.name === 'admin-dashboard'
                ? toggleDropdown(item.name)
                : open(item)
            "
          >
            <v-list-item-avatar size="20" tile class="mr-3">
              <template v-if="active(item)">
                <v-icon v-if="item.icon && item.icon.startsWith('mdi-')">{{ item.icon }}</v-icon>
                <img v-else-if="item.icon" :src="item.icon" alt="icons" />
              </template>
              <template v-else>
                <v-icon v-if="item.icon2 && item.icon2.startsWith('mdi-')">{{ item.icon2 }}</v-icon>
                <img v-else-if="item.icon2" :src="item.icon2" alt="icons" />
              </template>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title
                :class="{
                  'text-primary font-semibold': active(item),
                  'text-slate-600 hover:text-primary': !active(item),
                  'category-title-highlight': item.name === 'gmb' || item.name === 'social' || item.name === 'admin-dashboard'
                }"
                class="text-xl transition-colors duration-150"
              >
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
            <v-icon
              v-if="item.name === 'analytics' || item.name === 'gmb' || item.name === 'social' || item.name === 'admin-dashboard'"
              class="ml-auto transition-transform duration-200"
              :class="{
                'rotate-180 text-primary': (item.name === 'analytics' && showAnalyticsDropdown) || 
                                      (item.name === 'gmb' && showGMBDropdown) || 
                                      (item.name === 'social' && showSocialDropdown),
                'text-slate-500 hover:text-primary': !((item.name === 'analytics' && showAnalyticsDropdown) || 
                                            (item.name === 'gmb' && showGMBDropdown) || 
                                            (item.name === 'social' && showSocialDropdown)) ||
                              (item.name === 'admin-dashboard' && showAdminDropdown)
              }"
            >
              mdi-chevron-down
            </v-icon>
          </v-list-item>
          <template v-if="(item.name === 'analytics' && showAnalyticsDropdown) || (item.name === 'gmb' && showGMBDropdown) || (item.name==='social' && showSocialDropdown) || (item.name === 'admin-dashboard' && showAdminDropdown)">
            <template v-for="(subItem, j) in item.subMenus">
              <!-- Render as a category header if isCategory is true -->
              <v-list-item
                v-if="subItem.isCategory"
                :key="subItem.name + '-header'"
                class="ml-3 mt-1 non-clickable pt-1 pb-0"
              >
                <v-list-item-content>
                  <v-list-item-title class="text-base font-bold text-slate-700 uppercase tracking-wider">
                    {{ subItem.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <!-- Render as a clickable menu item if not a category -->
              <v-list-item
                v-else
                :key="subItem.name"
                :class="active(subItem) ? 'drawer__active_sub' : 'drawer__inactive_sub'"
                @click="open(subItem)"
                class="ml-3"
              >
                <!-- Avatar/Icon Section -->
                <v-list-item-avatar size="20" tile class="mr-3" v-if="!subItem.isCategory">
                  <template v-if="active(subItem)">
                    <v-icon 
                      v-if="subItem.icon && subItem.icon.startsWith('mdi-')"
                      :class="{ 'force-white-icon': shouldForceWhiteIcon(item.name, subItem.name) }"
                    >{{ subItem.icon }}</v-icon>
                    <img 
                      v-else-if="subItem.icon" 
                      :src="subItem.icon" 
                      alt="" 
                      :class="{ 'force-white-icon': shouldForceWhiteIcon(item.name, subItem.name) }"
                    />
                  </template>
                  <template v-else>
                    <v-icon 
                      v-if="subItem.icon2 && subItem.icon2.startsWith('mdi-')"
                      :class="{ 'force-white-icon': shouldForceWhiteIcon(item.name, subItem.name) }"
                    >{{ subItem.icon2 }}</v-icon>
                    <img 
                      v-else-if="subItem.icon2" 
                      :src="subItem.icon2 || subItem.icon" 
                      alt="" 
                      :class="{ 'force-white-icon': shouldForceWhiteIcon(item.name, subItem.name) }"
                    />
                    <v-icon 
                      v-else-if="subItem.icon && subItem.icon.startsWith('mdi-')"
                      :class="{ 'force-white-icon': shouldForceWhiteIcon(item.name, subItem.name) }"
                    >{{ subItem.icon }}</v-icon> 
                  </template>
                  <template v-if="item.name === 'admin-dashboard'">
                  <img v-if="active(subItem)" :src="subItem.icon" alt="icons" />
                  <img v-else :src="subItem.icon2" alt="icons" />
                </template>
              </v-list-item-avatar>

                <!-- Text Content -->
                <v-list-item-content>
                  <v-list-item-title
                    :class="{
                      'text-primary font-medium': active(subItem),
                      'text-slate-800 hover:text-primary': !active(subItem),
                    }"
                    class="text-xl transition-colors duration-150"
                    style="font-size: 0.95rem !important;"
                  >
                    {{ subItem.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </template>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-navigation-drawer
      app
      width="60"
      class="z-50 hidden md:block"
      v-if="!drawer && $route.path !== '/resources'"
      @input="$emit('input', drawer)"
    >
      <v-dialog v-model="showDialog" max-width="500">
        <v-card>
          <v-card-title class="headline">
            <v-btn
              v-if="showDialog"
              icon
              @click="closeDialog"
              class="close-dialog-btn"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
        </v-card>
      </v-dialog>

      <v-divider></v-divider>
      <v-list nav class="flex flex-col items-center">
        <template v-for="(item, i) in menus">
          <v-list-item
            :class="active(item)"
            class="w-full flex justify-center px-0"
            :key="i"
            @click="open(item)"
          >
            <v-list-item-avatar size="24" tile>
              <template v-if="active(item)">
                <v-icon v-if="item.icon && item.icon.startsWith('mdi-')" size="24">{{ item.icon }}</v-icon>
                <img v-else-if="item.icon" :src="item.icon" alt="icons" />
              </template>
              <template v-else>
                <v-icon v-if="item.icon2 && item.icon2.startsWith('mdi-')" size="24">{{ item.icon2 }}</v-icon>
                <img v-else-if="item.icon2" :src="item.icon2" alt="icons" />
              </template>
            </v-list-item-avatar>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import hopscotch from "hopscotch";
import WorkspaceMenu from "./WorkspaceMenu.vue";
import { auth } from "@/utils/firebase.utils";
import { onSnapshot, doc, getDoc } from "firebase/firestore";
import { colUsers } from "@/utils/firebase.utils.js";

import "hopscotch/dist/css/hopscotch.min.css"; // Import Hopscotch CSS

export default {
  components: {
    WorkspaceMenu,
  },
  props: {
    value: Boolean,
  },
  data() {
    return {
      drawer: true,
      showDialog: false,
      currentWorkspaceLogo: null,
      validLocation: false,
      showAnalyticsDropdown: true,
      showGMBDropdown: false,
      showSocialDropdown: false,
      showAdminDropdown: false,
      hasBoostPlan: true,
      unsubscribe:null,
    };
  },
  watch: {
    value(val) {
      this.drawer = val;
    },
    authUser: {
      immediate: true,
      handler() {
        this.checkUserPlan();
      },
    },
  },
  computed: {
    menus() {
      const routePath = this.$route.path; // Get the current route path
      let list = [];
      // Admin routes
      if (this.checkUserPlan()) {
        this.validLocation = true;
      }
      const isAdminRoute =
        routePath === "/power-users" || routePath === "/help-cms";

      // Check user plan first
      
      let tempItems = [
      // {
      //     name: "calendar",
      //     title: "Planner",
      //     icon: require("@/assets/img/plan_n.svg"),
      //     icon2: require("@/assets/img/plan_w.svg"),
      //     names: [""],
      //   },
      //   {
      //     name: "fly",
      //     title: "Posts",
      //     icon: require("@/assets/img/sidebar/posts_w.svg"),
      //     icon2: require("@/assets/img/sidebar/posts_n.svg"),
      //     names: ["fly", "error"],
      //   },
      //   {
      //     name: "analytics",
      //     title: "Analytics",
      //     icon: require("@/assets/img/sidebar/analytics_w.svg"),
      //     icon2: require("@/assets/img/sidebar/analytics_n.svg"),
      //     names: ["analytics"],
      //     subMenus: [
      //       {
      //         name: "dashboard",
      //         title: "Channels",
      //         icon: require("@/assets/img/sidebar/chl_n.svg"),
      //         icon2: require("@/assets/img/sidebar/channel_W.svg"),
      //         names: ["dashboard-new"],
      //       },
      //       // Conditionally include GMB if validLocation is true
      //       ...(this.validLocation
      //         ? [
      //             // {
      //             //   name: "gmb-analytics",
      //             //   title: "GMB",
      //             //   icon: require("@/assets/img/sidebar/chl_n.svg"),
      //             //   icon2: require("@/assets/img/sidebar/channel_W.svg"),
      //             //   names: ["Google Business Profile Analytics"],
      //             // },
      //           ]
      //         : []),
      //       {
      //         name: "content-insights",
      //         title: "Content",
      //         icon: require("@/assets/img/sidebar/content_n.svg"),
      //         icon2: require("@/assets/img/sidebar/content_w.svg"),
      //         names: ["content-insights"],
      //       },
      //     ],
      //   },
        // Only include GMB menu if user has boost plan
        ...(this.hasBoostPlan ? [{
          name: "gmb",
          title: "Local SEO",
          icon: "mdi-store-search-outline",
          icon2: "mdi-store-search-outline",
          names: ["GMB"],
          subMenus: [
            // Category: Manage Presence
            {
              name: "gmb-manage-presence", // Unique name for the category header
              title: "Manage Presence",
              isCategory: true, // Flag to identify as a category header
              names: [], // Category headers don't navigate
            },
            {
              name: "brand",
              title: "Brand Details",
              icon: "mdi-storefront-outline",
              icon2: "mdi-storefront-outline",
              names: [""],
            },
            {
              name: "locations",
              title: "Locations",
              icon: require("@/assets/img/sidebar/icons8-worldwide-location-50.png"),
              icon2: require("@/assets/img/sidebar/loc_g.svg"),
              names: ["locations"],
            },
            {
              name: "profiles",
              title: "Profiles Manager",
              icon: require("@/assets/img/sidebar/pr_g.png"),
              icon2: require("@/assets/img/sidebar/pr_gw.svg"),
              names: ["Profiles"],
            },
            {
              name: "seo-recommendations",
              title: "Recommendations",
              icon: "mdi-lightbulb-on-outline",
              icon2: "mdi-lightbulb-on-outline",
              names: [""],
            },
            // Category: Engage Customers
            {
              name: "gmb-engage-customers", // Unique name
              title: "Engage Customers",
              isCategory: true,
              names: [],
            },
            {
              name: "fly",
              title: "Posts",
              icon: require("@/assets/img/sidebar/posts_w.svg"),
              icon2: require("@/assets/img/sidebar/posts_n.svg"),
              names: ["fly", "error"],
            },
            {
              name: "offers",
              title: "Offers",
              icon: "mdi-tag-outline",
              icon2: "mdi-tag-outline",
              names: ["Offers"],
            },
            {
              name: "reviews",
              title: "Reviews",
              icon: "mdi-star-outline",
              icon2: "mdi-star-outline",
              names: ["Reviews Dashboard"],
            },
            // Category: Track & Improve
            {
              name: "gmb-track-improve", // Unique name
              title: "Track & Improve",
              isCategory: true,
              names: [],
            },
            {
              name: "seo-analytics",
              title: "Performance",
              icon: require("@/assets/img/sidebar/chl_n.svg"),
              icon2: require("@/assets/img/sidebar/channel_W.svg"),
              names: ["Google Business Profile Analytics"],
            },
            {
              name: "search-insights",
              title: "Search Insights",
              icon: "mdi-chart-line",
              icon2: "mdi-chart-line",
              names: ["Search Insights"],
            },
            ...(!this.isProduction() ? [{
              name: "seo-audit",
              title: "SEO Audit",
              icon: "mdi-magnify",
              icon2: "mdi-magnify",
              names: ["SEO Audit"],
            }] : []),
            {
              name: "footfall-insights",
              title: "Footfall Insights",
              icon: "mdi-chart-timeline-variant",
              icon2: "mdi-chart-timeline-variant",
              names: ["footfall-insights"],
            },
            // Show Local Rank Insights in all environments except production
            {
              name: "local-rank-insights",
              title: "Local Rank Insights",
              icon: "mdi-chart-box-outline",
              icon2: "mdi-chart-box-outline",
              names: ["Local Rank Insights"],
            },
            // Add Competitor Analysis menu item
            ...(!this.isProduction() ? [{
              name: "competitor-analysis",
              title: "Competitor Analysis",
              icon: "mdi-compare",
              icon2: "mdi-compare",
              names: ["Competitor Analysis"],
            }] : []),
            // Add Competitor Summary menu item
            {
              name: "competitor-summary",
              title: "Competitor Summary",
              icon: "mdi-clipboard-list-outline",
              icon2: "mdi-clipboard-list-outline",
              names: ["Competitor Summary"],
            },
            // Category: Strategy & Planning
            {
              name: "gmb-strategy-planning", // Unique name
              title: "Strategy & Planning",
              isCategory: true,
              names: [],
            },
            {
              name: "calendar",
              title: "Planner",
              icon: "mdi-calendar-month-outline",
              icon2: "mdi-calendar-month-outline",
              names: [""],
            },
          ],
        }] : []),
        ...[{
          name: "social",
          title: "Social Media",
          icon: "mdi-account-group-outline",
          icon2: "mdi-account-group-outline",
          names: ["Social"],
          subMenus: [
            {
              name: "calendar",
              title: "Planner",
              icon: "mdi-calendar-month-outline",
              icon2: "mdi-calendar-month-outline",
              names: [""],
            },
            {
              name: "fly",
              title: "Posts",
              icon: require("@/assets/img/sidebar/posts_w.svg"),
              icon2: require("@/assets/img/sidebar/posts_n.svg"),
              names: ["fly", "error"],
            },
            {
              name: "content-insights",
              title: "Content Stats",
              icon: require("@/assets/img/sidebar/content_n.svg"),
              icon2: require("@/assets/img/sidebar/content_w.svg"),
              names: ["content-insights"],
            },
            {
              name: "dashboard",
              title: "Channel Stats",
              icon: require("@/assets/img/sidebar/chl_n.svg"),
              icon2: require("@/assets/img/sidebar/channel_W.svg"),
              names: ["dashboard-new"],
            },
          ],
        }],
        ...(this.isAdmin ?[{
          name: "admin-dashboard",
          title: "Admin Dashboard",
          icon: require("@/assets/img/review.png"),
          icon2: require("@/assets/img/review.png"),
          names: ["Admin"],
          subMenus: [
            {
              name: "swot",
              title: "SWOT Analysis",
              icon: require("@/assets/img/plan_n.svg"),
              icon2: require("@/assets/img/plan_w.svg"),
              names: [""],
            },
          ],
        }] : []),
      ];
      if (this.currentUID == auth.currentUser.uid) {
        const socialMenu = tempItems.find(item => item.name === "social");
        if (socialMenu) {
          socialMenu.subMenus.unshift({
            name: "connected-apps",
            title: "Channels",
            icon: require("@/assets/img/sidebar/connect_w.svg"),
            icon2: require("@/assets/img/sidebar/connect_n.svg"),
            names: ["connected-apps"],
          });
        }
      }
      if (this.currentWorkspace && this.currentWorkspace?.role === "Client") {
        tempItems = [
        ...(this.hasBoostPlan ? [{
          name: "gmb",
          title: "Local SEO",
          icon: require("@/assets/img/review.png"),
          icon2: require("@/assets/img/review.png"),
          names: ["GMB"],
          subMenus: [
            {
                name: "gmb-analytics",
                title: "Performance",
                icon: require("@/assets/img/sidebar/chl_n.svg"),
                icon2: require("@/assets/img/sidebar/channel_W.svg"),
                names: ["Google Business Profile Analytics"],
            },
          ],
          }] : []),
          ...[{
          name: "social",
          title: "Social Media",
          icon: require("@/assets/img/review.png"),
          icon2: require("@/assets/img/review.png"),
          names: ["Social"],
          subMenus: [
              {
                name: "calendar",
                title: "Planner",
                icon: require("@/assets/img/plan_n.svg"),
                icon2: require("@/assets/img/plan_w.svg"),
                names: [""],
              },
              {
                name: "content-insights",
                title: "Content Stats",
                icon: require("@/assets/img/sidebar/content_n.svg"),
                icon2: require("@/assets/img/sidebar/content_w.svg"),
                names: ["content-insights"],
              },
              {
                name: "dashboard",
                title: "Channel Stats",
                icon: require("@/assets/img/sidebar/chl_n.svg"),
                icon2: require("@/assets/img/sidebar/channel_W.svg"),
                names: ["dashboard-new"],
              },
            ],
          }],
        ];
      }
      const generalItems = tempItems;

      // Only include these items on admin routes
      const adminItems = [
        {
          name: "admin",
          title: "Admin - Campaign",
          icon: require("@/assets/img/sidebar/campaign-userwhite.svg"),
          icon2: require("@/assets/img/sidebar/campaign-user.svg"),
          names: ["admin"],
        },
        {
          name: "help-cms",
          title: "Admin - Platforms",
          icon: require("@/assets/img/sidebar/admin.svg"),
          icon2: require("@/assets/img/sidebar/adminwhite.svg"),
          names: ["update-help-cms"],
        },
      ];

      if (this.isAdmin && isAdminRoute) {
        // If the user is an admin and on an admin route, show only admin items
        list = adminItems;
      } else if (!isAdminRoute) {
        // For all other routes, show the general items
        list = generalItems;
      }

      return list;
    },
  },
  created(){
    this.checkUserPlan();
  },
  methods: {
    isProduction() {
      return process.env.VUE_APP_ENV === "production";
    },
    shouldForceWhiteIcon(parentName, subItemName) {
      if (parentName === 'gmb') {
        return ['locations', 'profiles', 'fly', 'seo-analytics'].includes(subItemName);
      }
      if (parentName === 'social') {
        // Assuming 'dashboard' is the name for 'Channel Stats'
        // and 'connected-apps' for 'Channels'
        // Added 'fly' for the 'Posts' sub-item under 'Social Media'
        return ['connected-apps', 'content-insights', 'dashboard', 'fly'].includes(subItemName);
      }
      if (parentName === 'admin-dashboard') {
        return ['swot'].includes(subItemName);
      }
      return false;
    },
    async fetchLocationsConnectionStatus() {
      const workspaceRef = collection(
        db,
        "users",
        this.currentUID,
        "fly_workspaces"
      );
      try {
        const querySnapshot = await getDocs(workspaceRef);
        for (let doc of querySnapshot.docs) {
          const data = doc.data();
          if (
            doc.id !== "default" &&
            data.storeWorkspace &&
            data.status === "connected" &&
            data.connected_apps &&
            data.connected_apps.length > 0
          ) {
            return true;
          }
        }
        return false;
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    },
    async checkUserPlan() {
      const requiredPlan = process.env.VUE_APP_BROADCAST_PLAN || "boost";
      this.hasBoostPlan = true; // this.authUser?.fly_plan === requiredPlan;
    },
    loadCurrentWorkspace() {
      const workspaceDocRef = doc(
        colUsers,
        this.currentUID,
        "fly_workspaces",
        this.WID
      );
      this.unsubscribe = onSnapshot(
        workspaceDocRef,
        (doc) => {
          if (doc.exists()) {
            const workspaceData = doc.data();
            this.currentWorkspaceLogo = workspaceData.logo_original || "";
            this.currentWorkspaceName = workspaceData.name || "";
          } else {
            console.error("No such document!");
          }
        },
        (error) => {
          console.error("Error getting document:", error);
        }
      );
    },
    toggleAnalyticsDropdown() {
      this.showAnalyticsDropdown = !this.showAnalyticsDropdown;
    },
    toggleAdminDropdown() {
      this.showAdminDropdown = !this.showAdminDropdown;
    },
    active(item) {
      let { names } = item;
      let { name } = this.$route;
      let isActive = name == item.name || names.indexOf(name) != -1;
      return isActive ? "drawer__active" : "drawer__inactive";
    },
    open({ name, title }) {
      if (this.$router.currentRoute.name !== name) {
        this.$router.push({ name }).catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            console.error(err);
          }
        });
      }
      this.$root.$emit("tab-selected", title); // Emit the selected tab's title globally
    },
    checkBoostPlan(){
      if(this.hasBoostPlan){
        this.showGMBDropdown = true;
      }else{
        this.showSocialDropdown = true;
      }
    },
    closeDialog() {
      this.showDialog = false;
    },
    renewSubscription() {
      this.$router.push("/subscription");
      this.closeDialog();
    },
    toggleDropdown(name) {
      if (name === 'analytics') {
        this.showAnalyticsDropdown = !this.showAnalyticsDropdown;
      } else if (name === 'gmb') {
        this.showGMBDropdown = !this.showGMBDropdown;
        if(this.showGMBDropdown && this.showSocialDropdown){
          this.showSocialDropdown = false;
        }
        if(this.showGMBDropdown && this.showAdminDropdown){
          this.showAdminDropdown = false;
        }
      }
      else if (name === 'social'){
        this.showSocialDropdown = !this.showSocialDropdown;
        if(this.showGMBDropdown && this.showSocialDropdown){
          this.showGMBDropdown = false;
        }
        if(this.showSocialDropdown && this.showAdminDropdown){
          this.showAdminDropdown = false;
        }
      }
      else if (name === 'admin-dashboard'){
        this.showAdminDropdown = !this.showAdminDropdown;
        if(this.showGMBDropdown && this.showAdminDropdown){
          this.showGMBDropdown = false;
        }
        if(this.showSocialDropdown && this.showAdminDropdown){
          this.showSocialDropdown = false;
        }
      }
    },
  },
  async mounted() {
    this.checkBoostPlan();
    this.loadCurrentWorkspace();
  },
  beforeDestroy() {
    if (this.unsubscribe) this.unsubscribe();
  },
};
</script>

<style lang="scss">
// Updated SCSS variables to use new Tailwind colors
$sidebar-bg-color: #111827; // Tailwind gray-900 (dark background)
$sidebar-active-bg-color: #1f2937; // Tailwind gray-800 (background for active items, if uncommented)
$sidebar-text-active: #ffffff; // white
$sidebar-text-inactive: #9ca3af; // Tailwind gray-400 (light gray)
$sidebar-text-hover: #ffffff; // white

.v-navigation-drawer {
  .v-navigation-drawer__content {
    background-color: $sidebar-bg-color !important;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .drawer-menu {
    height: calc(100vh - 70px);
  }
}

.drawer__active i, .drawer__active_sub i { 
  color: $sidebar-text-active !important;
}

.drawer__inactive i {
  color: $sidebar-text-inactive !important;
  &:hover {
    color: $sidebar-text-hover !important;
  }
}

.drawer__active {
  //background-color: $sidebar-active-bg-color !important; 
  color: $sidebar-text-active !important;
  border-radius: 6px; // Slightly less rounded than before
  padding-left: 4px !important; 
  margin-left: 0 !important; 
}
.drawer__inactive { 
  color: $sidebar-text-inactive !important;
  border-radius: 6px;
  padding-left: 4px !important; 
  margin-left: 0 !important; 
  &:hover {
    background-color: rgba(255, 255, 255, 0.08) !important; // Subtle hover for dark background
    color: $sidebar-text-hover !important;
  }
}

.drawer__active_sub {
  //background-color: $sidebar-active-bg-color !important; // Using the same active for sub-items now, as per screenshot
  color: $sidebar-text-active !important;
  border-radius: 6px;
  padding-left: 2px !important; // Adjusted padding for sub-items
  .v-list-item__title {
    color: $sidebar-text-active !important;
  }
}

.drawer__inactive_sub {
  color: $sidebar-text-inactive !important;
  border-radius: 6px;
  padding-left: 2px !important; // Adjusted padding
   .v-list-item__title {
    color: $sidebar-text-inactive !important;
    &:hover{
        color: $sidebar-text-hover !important;
    }
  }
  &:hover {
    background-color: rgba(255, 255, 255, 0.08) !important; // Subtle hover for dark background
    .v-list-item__title { color: $sidebar-text-hover !important; }
  }
}

.non-clickable .v-list-item__title {
  color: #9ca3af !important; // Tailwind gray-400, ensures category headers are light
}

.fly-logo-dark-bg {
  filter: brightness(0) invert(1);
}

.category-title-highlight {
  color: #ffffff !important;
  font-weight: 700 !important;
  font-size: 1.2rem !important; // Slightly reduced from 1.25rem
}

.force-white-icon.v-icon {
  color: white !important;
}

img.force-white-icon {
  filter: brightness(0) invert(1) !important;
}

// Attempt to style icons within WorkspaceMenu (dropdown header)
.workspace-menu {
  // Target icons if they are within a v-list-item__avatar (common for Vuetify)
  .v-list-item__avatar img,
  .v-list-item__avatar .v-icon {
    filter: brightness(0) invert(1) !important; // For images
    color: white !important;                   // For v-icon
  }

  // Target icons if they are part of the Vuetify select's selection display
  .v-select__selection {
    color: white !important; // For the text

    img, .v-icon { // Existing icon styling
      filter: brightness(0) invert(1) !important;
      color: white !important; 
    }
  }
  
  // More general catch-all for direct img or v-icon children,
  // in case the structure is different.
  > img, > .v-icon, .v-input__icon img, .v-input__icon .v-icon {
     filter: brightness(0) invert(1); // Non-!important to be less aggressive
     color: white;
  }
}

// ... Remove or update .text-orange-300, .text-whites if they were solely for old sidebar ...
</style>
